import { Artist, Order, OrderStatus } from '@favid-inc/api';
import { OrderByElement, WhereElement } from '@favid-inc/api/lib/rest';
import { Action, Filter } from 'core/generic';
import { ArtistOrdersTable, fetchOrders } from 'features/orders';

import moment from 'moment';
import React from 'react';
import { artistOrdersReducer } from './controller';

interface Props {
  artist: Artist;
}

export interface ArtistOrdersState {
  selectedSegment?: OrderStatus;
  isLoading: boolean;
  orderBy: OrderByElement;
  filter: Filter;
  list: Order[];
  total: number;
}

const initialState = {
  isLoading: false,
  list: [],
  total: 0,
  orderBy: {
    attr: 'id',
    exp: 'ASC' as 'ASC',
  },
  filter: {
    page: 0,
    itensPerPage: 20,
  },
};

const reducer = artistOrdersReducer(initialState);

class AritstOrdersComponent extends React.Component<Props> {
  state: ArtistOrdersState = initialState;

  componentDidMount() {
    const filter: Filter = {
      ...this.state.filter,
      where: [{ attr: 'artistId', exp: '=', value: this.props.artist.id }],
    };
    const { orderBy } = this.state;

    fetchOrders({ filter, orderBy, dispatch: this.dispatch });
    this.setState({ filter });
  }

  dispatch = (action: Action) => {
    this.setState(() => reducer(this.state, action));
  };

  onPaginateChange = async (selectedItem: { selected: number }) => {
    const filter: Filter = {
      ...this.state.filter,
      page: selectedItem.selected,
      itensPerPage: this.state.filter.itensPerPage,
    };
    const { orderBy } = this.state;

    fetchOrders({ filter, orderBy, dispatch: this.dispatch });
    this.setState({ filter });
  };

  onTableFilterChange = async (where: WhereElement[] = []) => {
    where = [
      ...where,
      { attr: 'artistId', exp: '=', value: this.props.artist.id },
    ] as WhereElement[];
    const filter = { ...this.state.filter, where };
    const { orderBy } = this.state;

    this.setState({ filter });
    fetchOrders({ filter, orderBy, dispatch: this.dispatch });
  };

  onChangeSort = (orderBy: OrderByElement) => {
    this.setState({ orderBy });
    // const { filter } = this.state;
    // fetchOrders({ filter, orderBy, dispatch: this.dispatch });
  };

  renderDate(icon: string, milisecounds?: number, description?: string) {
    if (!milisecounds) {
      return null;
    }

    const formatedDate = moment(milisecounds).format('LLL');
    return (
      <div
        className='ui icon'
        data-tooltip={description}
        data-position='top left'
      >
        <i className={`icon ${icon}`} />
        {formatedDate}
      </div>
    );
  }

  render() {
    const { isLoading, filter, total, list, orderBy } = this.state;

    return (
      <div className='ui segment' style={{ marginTop: '1em' }}>
        <div className='header'>
          <h3>Pedidos</h3>
          <br />
        </div>
        <div className='ui bottom attached tab active'>
          <ArtistOrdersTable
            total={total}
            orders={list}
            filter={filter}
            orderBy={orderBy}
            isLoading={isLoading}
            isArtistSearchDisable={true}
            onChangeSort={this.onChangeSort}
            onPaginateChange={this.onPaginateChange}
            onFilterChange={this.onTableFilterChange}
          />
        </div>
      </div>
    );
  }
}

export const ArtistOrders = AritstOrdersComponent;
